export default __webpack_public_path__ + "static/hotel-951398_1280-683c46a5fd998d5a2e2f9d33d7e77c08.png";